const pay = {
  // 充值盒子-支付宝扫码
  QrAlipayBox: `/payApi/v1/Pay/QrAlipayBox`,
  // 充值盒子-支付宝扫码
  QrWechatBox: `/payApi/v1/Pay/QrWechatBox`,
  // 直充游戏支付宝扫码
  QrAlipayGame: `/payApi/v1/Pay/QrAlipayGame`,
  // 直充游戏微信扫码
  QrWechatGame: `/payApi/v1/Pay/QrWechatGame`,
  // 充值状态校验
  PayStatusUrl: `/payApi/v1/PayStatus/Check`,
  // 获取用户最近是否有充值
  PayCheck: `/payApi/v1/PayStatus/payCheck`,
  // 充值游戏-pc余额/金币支付
  BalancePay: `/payApi/v1/Pay/BalancePay`,
  // 用户钱包余额明细
  UserWalletDetailed: `/userApi/v1/UserWallet/pcBalanceDetailed`,
  // 用户钱包金币明细
  UserGoldDetailed: `/userApi/v1/UserWallet/pc_gold_detailed`,
  // 用户钱包金币明细-新
  UserGoldLog: `/userApi/v1/UserWallet/mobile_gold_log`,
  // 用户钱包元宝明细
  UserGoldIngotDetailed: `/userApi/v1/UserWallet/gold_ingot_details`,
  // 余额类型
  screenFactor: `/userApi/v1/UserWallet/screen_factor`,
  // 交易类型
  pcScreenFactor: `/userApi/v1/UserWallet/pcScreenFactor`,
  // 公众号充值盒币
  JsapiWechatBox: `/payApi/v1/Pay/JsapiWechatBox`
};

export default pay;
